/* eslint-disable */
// Admin interface translations — fr / en / he
// Used by admin.vue and adminUser.vue via t('key')
export const adminUI = {
  fr: {
    // ── Auth ────────────────────────────────────────────
    adminTitle: 'Admin Panel',
    loginPromptGoogle: 'Connecte-toi avec ton compte Google admin',
    accessDenied: '❌ Accès refusé — ce compte n\'est pas autorisé',
    connecting: 'Connexion…',
    signInGoogle: 'Se connecter avec Google',
    emailNotVerified: 'Email non vérifié',
    emailNotVerifiedMsg: 'Vérifie ton email avant de pouvoir éditer des parcours.',
    backToDashboard: 'Tableau de bord',
    editorTitle: 'Éditeur de parcours',
    loginPrompt: 'Connecte-toi pour accéder à l\'éditeur.',
    loginError: '❌ Erreur de connexion',

    // ── Game selection ───────────────────────────────────
    chooseGame: 'Choisir un parcours',
    createNew: '➕ Créer un nouveau parcours',
    editExisting: '✏️ Modifier un parcours existant',
    newGameSettings: 'Nouveau parcours',
    newGameNotice: '💡 Ces paramètres sont obligatoires mais modifiables à tout moment dans les réglages.',
    gameName: 'Nom du parcours *',
    gameLabel: 'Nom du parcours',
    urlIdentifier: 'Identifiant URL *',
    urlNote: '(sans espaces ni accents)',
    availableLanguages: 'Langues disponibles *',
    langHebrew: '🇮🇱 Hébreu',
    langArabic: '🇸🇦 Arabe',
    langFrench: '🇫🇷 Français',
    langEnglish: '🇬🇧 Anglais',
    mapCenter: 'Centre carte (Lat / Lng) *',
    lastPointNumber: 'Dernier numéro de point *',
    visitOrder: 'Ordre de visite *',
    gameMode: 'Mode du jeu *',
    modeGeographic: 'Géographique',
    modeGeographicDesc: 'Contenu lié à un lieu physique. Monuments, sites historiques.',
    modeStory: 'Histoire',
    modeStoryDesc: 'Chapitres dans l\'ordre séquentiel. Récit, aventure guidée.',
    startingLocation: 'Lieu de départ (optionnel)',
    cancel: 'Annuler',
    createGame: 'Créer le parcours →',
    selectGame: 'Sélectionner un parcours',
    back: '← Retour',
    logout: 'Déconnexion',
    myGames: 'Mes parcours',
    noGamesFound: 'Aucun parcours trouvé.',

    // ── Topbar ───────────────────────────────────────────
    tabPoints: '📍 Points',
    tabSettings: '⚙️ Paramètres',
    adminLanguage: 'Langue interface',

    // ── Points list ──────────────────────────────────────
    screen: 'Écran :',
    info: 'Info :',
    exercise: 'Exercice :',
    missingWord: 'Mot manquant :',
    save: '💾 Sauvegarder',
    edit: '✏️ Éditer',
    delete: '🗑️',
    noImage: 'Pas d\'image',
    noPuzzleImage: 'Pas d\'image puzzle',
    memoryUsesPointImages: '🃏 Les images du point sont utilisées comme paires de cartes.',
    coordinates: '📍 Coordonnées',
    lat: 'Lat',
    lng: 'Lng',
    pickOnMap: '📍 Choisir sur la carte',
    hideCoords: 'Masquer lat/lng',
    showCoords: 'Voir lat/lng',
    sectionScreen: '📱 Écran de navigation',
    sectionInfo: 'ℹ️ Écran d\'information',
    sectionExercise: '🎯 Écran d\'exercice',
    missingWordReadLabel: '🔤 Mot manquant :',
    navOnly: '🧭 Navigation seule',
    sectionPosition: '📍 Position géographique',
    positionDesc: 'Changer la position de ce point sur la carte.',
    sectionScreenHint: 'Choisissez comment les joueurs trouvent ce point.',
    sectionInfoHint: 'Ajoutez du contenu affiché avant l\'exercice. Cette étape est optionnelle.',
    sectionExerciseHint: 'Choisissez le type d\'activité à compléter sur ce point.',
    sectionPositionHint: 'Définissez les coordonnées GPS de ce point sur la carte.',

    // ── Edit form — basic ─────────────────────────────────
    pointNumber: 'Numéro du point',
    image: 'Image',
    changeImage: '🔄 Changer l\'image',
    chooseImage: '📁 Choisir une image',
    imageHint: '📸 Réduite à 450 px. GPS extrait automatiquement si disponible.',
    navigationScreen: 'Écran de navigation',
    screenImagesList: 'Liste d\'images',
    screenDynamicMap: 'Carte dynamique',
    screenCarousel: 'Carrousel',
    screenMissingWord: 'Mot manquant',
    missingWordLabel: 'Mot manquant (pour recherche de panneau)',
    missingWordVisible: 'Mot visible sur le panneau',
    pointInformation: 'Information du point',
    labelText: 'Texte',
    labelAudio: 'Audio',
    labelVideo: 'Vidéo',
    labelAR: '📷 AR',
    labelPhone: '📞 Téléphone',
    waypoint: 'Waypoint',
    labelVideoId: '🎬 Vidéo ID',
    noAudio: 'pas d\'audio',
    savePoint: '💾 Sauvegarder le point',
    imageUploadHint: '📸 Téléchargez une image — coordonnées GPS extraites automatiquement si disponibles.',
    audioUrl: 'URL Audio',
    editPhoto: '✏️ Éditer',

    // ── Phone ─────────────────────────────────────────────
    callerName: 'Nom de l\'appelant',
    callerNamePlaceholder: 'ex. Inspecteur Cohen',
    phoneAudioUrl: 'URL audio de l\'appel',

    // ── Video ─────────────────────────────────────────────
    youtubeUrl: 'URL ou ID YouTube',
    shortsDetected: '📱 Shorts détecté',
    youtubeWarning: '⚠️ Ajoute un ID YouTube pour que la vidéo soit visible.',

    // ── AR ────────────────────────────────────────────────
    arDirection: '🧭 Direction d\'affichage',
    arPreset: 'Preset',
    arExactDeg: 'Degrés exacts',
    arNorth: 'Nord (0°)',
    arNE: 'Nord-Est (45°)',
    arEast: 'Est (90°)',
    arSE: 'Sud-Est (135°)',
    arSouth: 'Sud (180°)',
    arSW: 'Sud-Ouest (225°)',
    arWest: 'Ouest (270°)',
    arNW: 'Nord-Ouest (315°)',
    arEffectUrl: 'URL effet visuel (.webm ou .gif)',
    arSearchWord: 'Mot à chercher (optionnel)',
    arSearchWordPlaceholder: 'Ex : fontaine, aigle, fresque…',
    arSearchWordHint: 'Si renseigné, affiche "Cherchez le/la [mot]" sur l\'écran AR.',
    arGifCount: 'Nombre de GIFs',
    arGif1: '1 (simple)',
    arGif2: '2 (côte à côte)',
    arSpacing: 'Espacement (px)',
    arSpacingHint: 'Négatif = chevauchement, positif = écart',
    arGrowAnimation: 'Apparition de l\'image',
    arGrow: '📈 Grandir',
    arAppear: '⚡ Apparaître directement',
    rushHourTitle: '🚗 Rush Hour',

    // ── Exercise types ────────────────────────────────────
    exerciseType: 'Type d\'exercice',
    exerciseQuestions: 'Questions',
    exercisePuzzle: 'Puzzle',
    exerciseMultipleMatch: 'Multiple match',
    exerciseMemory: '🃏 Memory',
    exerciseJusteFaux: '✅ Vrai / Faux',
    exerciseMotManquant: '📝 Mots manquants',
    exerciseRushHour: '🚗 Rush Hour',
    exerciseSignCard: '🖊️ Carte à signer',

    // ── Sign card ─────────────────────────────────────────
    signCardTitle: '🖊️ Carte à signer',
    signCardImage: 'Image de la carte',
    signCardZone: 'Zone signature',
    signCardHeight: 'Hauteur :',
    signCardVAlign: 'Position verticale',
    signCardHAlign: 'Position horizontale',
    alignTop: 'Haut',
    alignCenter: 'Centre',
    alignBottom: 'Bas',
    alignLeft: 'Gauche',
    alignRight: 'Droite',

    // ── Puzzle ────────────────────────────────────────────
    puzzleImage: 'Image puzzle',
    puzzleImageHint: '🧩 Rognée en carré automatiquement',

    // ── Memory ────────────────────────────────────────────
    memoryImages: '🃏 Images personnalisées (optionnel, max 6)',
    memoryImagesHint: 'Si aucune image n\'est ajoutée, les images du point sont utilisées. Réduites à 120×120.',
    addImage: '📁 Ajouter une image',

    // ── Multiple match ────────────────────────────────────
    mmTitle: 'Paires — 4 images + labels',
    mmHint: '🖼️ Images rognées à 150×200 automatiquement',
    mmPair: 'Paire',
    mmLabel: 'Label',
    mmLabelPlaceholder: 'Mot ou phrase',

    // ── Mots manquants ────────────────────────────────────
    mmqHint: 'Entourez les mots à trouver avec des accolades : {mot}',
    mmqPlaceholder: 'ex : Le roi {David} a régné sur {Jérusalem} pendant {40} ans.',
    mmqHoles: 'trou(s) détecté(s)',
    mmqMode: 'Mode',
    mmqVisible: '👀 Mots visibles',
    mmqHidden: '✏️ L\'utilisateur écrit',

    // ── Vrai / Faux ───────────────────────────────────────
    jfTitle: '✅ Vrai / Faux',
    jfQuestion: 'Question',
    jfOptions: 'Options',
    jfOptionPlaceholder: 'Option…',
    jfAddOption: '+ Ajouter une option',
    jfQuestionPlaceholder: 'ex : Lesquelles de ces affirmations sont vraies ?',

    // ── Coordinates / Waypoints ───────────────────────────
    latitude: 'Latitude',
    longitude: 'Longitude',
    latitudePlaceholder: '32.657',
    longitudePlaceholder: '35.417',
    waypoints: 'Waypoints (optionnel)',
    addWaypoint: '+ Ajouter waypoint',

    // ── Questions ─────────────────────────────────────────
    questionsTitle: '❓ Questions',
    correctAnswer: '✅ Bonne réponse',
    wrongAnswer1: '✗ Mauvaise 1',
    wrongAnswer2: '✗ Mauvaise 2',
    wrongAnswer3: '✗ Mauvaise 3',
    saveQuestion: '💾 Sauvegarder',
    addQuestion: '➕ Ajouter une question',
    newQuestion: 'Nouvelle question',
    questionText: 'Texte de la question *',
    linkedToPoint: 'Lié au point #',
    questionRequired: 'Question et bonne réponse obligatoires.',

    // ── Add point buttons ─────────────────────────────────
    addPoint: 'Ajouter un point',
    addNavPoint: '🧭 Ajouter un point de navigation',
    newPoint: 'Nouveau point',
    points: 'points',
    planPointsLimit: 'Le plan actuel est limité à {max} points. Pour en ajouter davantage, passez à un plan supérieur.',
    pointAdded: '✅ Point ajouté',
    newNavPoint: '🧭 Nouveau point de navigation',
    navPointInfo: 'Un point de navigation n\'a pas d\'exercice ni d\'écran d\'information. Il sert uniquement à guider le joueur vers un lieu.',
    pointNumberRequired: 'Numéro du point *',
    pointInformationText: 'Texte d\'information',
    requiredFields: 'Numéro, latitude et longitude sont obligatoires.',
    pointExists: 'Le point existe déjà.',
    infoRequired: 'Au moins un champ est requis : audio, texte, vidéo, AR ou téléphone.',
    imageRequired: 'Une image est obligatoire.',

    // ── Settings — Map ────────────────────────────────────
    settingsMap: '🗺️ Paramètres de la carte',
    centerLat: 'Latitude centre',
    centerLng: 'Longitude centre',
    zoom: 'Zoom',
    saveMap: '💾 Sauvegarder la carte',

    // ── Settings — Display name ───────────────────────────
    displayName: '🏷️ Nom d\'affichage (visible par les joueurs)',
    displayNameHint: 'Ce nom apparaît sur la page d\'accueil des joueurs. Peut contenir des espaces et des accents.',
    saveDisplayName: '💾 Sauvegarder le nom',

    // ── Settings — Starting location ──────────────────────
    settingsStartLocation: '📍 Lieu de départ',
    startLocationHint: 'Si renseigné, la page d\'accueil affichera "Rendez-vous à : [nom]" au lieu de la phrase Waze.',
    startLocationPlaceholder: 'Ex : Parking de la mairie, Place Centrale…',
    saveStartLocation: '💾 Sauvegarder',

    // ── Settings — Last point ─────────────────────────────
    settingsLastPoint: '🏁 Dernier point (fin de jeu)',
    lastPointHint: 'Numéro du point qui termine le parcours. Ce point est affiché en rouge sur la carte.',
    lastPointPlaceholder: 'Numéro du dernier point',
    saveLastPoint: '💾 Sauvegarder',

    // ── Settings — Visit orders ───────────────────────────
    settingsOrders: '🔀 Ordres de visite',
    ordersHint: 'Chaque ordre est une liste de numéros séparés par des virgules. Un ordre est assigné aléatoirement à chaque joueur.',
    noOrders: 'Aucun ordre défini.',
    order: 'Ordre',
    addOrder: '+ Nouvel ordre',
    saveOrders: '💾 Sauvegarder les ordres',

    // ── Settings — URL ────────────────────────────────────
    gameUrl: '🔗 URL du parcours',
    copy: '📋 Copier',

    // ── Settings — Game options ───────────────────────────
    settingsOptions: '⚙️ Options du jeu',
    randomQuestions: 'Questions aléatoires',
    settingsMode: 'Mode du parcours',
    modeGeographicFull: 'Géographique — le contenu de chaque point est lié à son lieu physique. Idéal pour des monuments, sites historiques.',
    modeStoryFull: 'Histoire — raconté dans l\'ordre séquentiel. Idéal pour un récit, une aventure guidée.',
    emptyPoints: '⚠️ Points sans contenu en mode Géographique :',
    emptyPointsHint: 'Ces points n\'ont ni information ni exercice. Le joueur avancera automatiquement.',
    saveMode: '💾 Sauvegarder le mode',

    // ── Settings — Languages ──────────────────────────────
    settingsLangs: '🌍 Langues disponibles',
    langsHint: 'Choisissez les langues proposées aux joueurs. La première cochée sera la langue par défaut.',
    saveLangs: '💾 Sauvegarder les langues',

    // ── Settings — Background image ───────────────────────
    bgImage: '🖼️ Image de fond de la page d\'accueil',
    bgImageHint: 'Cette image apparaît en arrière-plan quand les joueurs arrivent sur ton parcours.',
    saveBgImage: '💾 Sauvegarder l\'image',
    saving: '⏳ Sauvegarde…',

    // ── Delete confirmation ───────────────────────────────
    deleteTitle: 'Supprimer le point',
    deleteMsg: 'Cette action est irréversible. Le point et ses images seront définitivement supprimés de toutes les langues.',
    confirmDelete: 'Supprimer',
    deleting: 'Suppression…',

    // ── Map picker ────────────────────────────────────────
    mapPickerHint: '📍 Clique sur la carte pour choisir la position',
    confirm: 'Confirmer',

    // ── Toast messages ────────────────────────────────────
    toastPointSaved: 'Point sauvegardé !',
    toastPointCreated: 'Point créé !',
    toastPointDeleted: 'Point supprimé !',
    toastQuestionSaved: 'Question sauvegardée !',
    toastQuestionCreated: 'Question créée !',
    toastDisplayNameSaved: 'Nom d\'affichage sauvegardé !',
    toastStartLocationSaved: 'Lieu de départ sauvegardé !',
    toastMapSaved: 'Carte sauvegardée !',
    toastLastPointSaved: 'Dernier point sauvegardé !',
    toastOrdersSaved: 'Ordres sauvegardés !',
    toastOrderDeleted: 'Ordre supprimé !',
    toastUrlCopied: 'URL copiée !',
    toastBgImageSaved: 'Image de fond sauvegardée !',
    toastBgImageError: 'Erreur lors de la sauvegarde de l\'image.',
    toastGameCreated: 'Parcours créé !',
    toastNavPointCreated: 'Point de navigation créé !',
    toastLangsSaved: 'Langues sauvegardées !',

    // ── Story mode explanation ────────────────────────────
    storyModeTitle: '📖 Mode Histoire — comment ça fonctionne',
    storyModeDesc: 'En mode Histoire, le contenu est présenté dans l\'ordre des numéros de points (1, 2, 3…), indépendamment de l\'ordre de navigation GPS.',
    storyModeEdit: 'Pour modifier le contenu, éditez chaque point normalement dans l\'onglet Points.',

    // ── Field worker link (admin side) ────────────────────
    fieldLinkTitle: '🧭 Lien terrain (photo + GPS)',
    fieldLinkHint: 'Génère un lien à envoyer à la personne qui va photographier les points et enregistrer les coordonnées GPS. La page est vide — elle ne montre pas les anciennes données.',
    fieldLinkGenerating: '⏳ Génération…',
    fieldLinkGenerate: '🔗 Générer un lien terrain',
    fieldLinkCopied: 'Lien copié !',

    // ── Field worker page ─────────────────────────────────
    fwLoading: 'Chargement…',
    fwInvalidTitle: 'Lien invalide',
    fwInvalidMsg: 'Ce lien est expiré ou incorrect. Demande un nouveau lien à l\'administrateur.',
    fwPointsToFill: 'point(s) à remplir',
    fwTutoPhotoTitle: 'Photo',
    fwTutoPhotoBody: 'Prenez une photo de quelque chose de clairement visible depuis ce point — une pancarte, un bâtiment, un monument. Cette photo sera affichée aux joueurs.',
    fwTutoGpsTitle: 'Coordonnées GPS',
    fwTutoGpsBody: 'Placez-vous exactement à l\'endroit du point et entrez vos coordonnées GPS. Dans Google Maps, maintenez appuyé sur votre position → les coordonnées apparaissent en bas.',
    fwTutoSaveTitle: 'Sauvegarde',
    fwTutoSaveBody: 'Chaque point se sauvegarde séparément. Vous pouvez faire les points dans n\'importe quel ordre et revenir plus tard sur ce lien.',
    fwStart: 'Commencer →',
    fwSavedCount: 'sauvegardés',
    fwDoneTag: '✅ Sauvegardé',
    fwTodoTag: 'À remplir',
    fwPhotoLabel: '📸 Photo',
    fwPhotoHint: 'Quelque chose de clairement visible depuis ce point (pancarte, bâtiment, monument…)',
    fwChoosePhoto: '📁 Choisir une photo',
    fwGpsLabel: '📍 Coordonnées GPS',
    fwGpsHint: 'Dans Google Maps : maintenez appuyé sur votre position → les coordonnées apparaissent en bas.',
    fwLatPlaceholder: 'Latitude  ex: 32.657',
    fwLngPlaceholder: 'Longitude  ex: 35.417',
    fwSaving: '⏳ Sauvegarde…',
    fwModify: '🔄 Modifier',
    fwSavePoint: '💾 Sauvegarder ce point',
    fwSaveError: 'Erreur lors de la sauvegarde. Réessaie.',
    fwAllDone: '🎉 Tous les points ont été remplis ! L\'administrateur peut maintenant finaliser le parcours.',
    fwToastSaved: 'Point sauvegardé ✅',
    fwPickOnMap: 'Choisir sur la carte',

    // ── Dashboard ─────────────────────────────────────────
    dbTitle: 'Mon espace Eifoany',
    dbLoginDesc: 'Connecte-toi avec Google pour accéder à ton espace créateur',
    dbAuthError: '❌ Erreur de connexion, réessaie.',
    dbVerifyEmail: 'Vérifie ton email',
    dbVerifyEmailMsg: 'Un email de vérification a été envoyé. Clique sur le lien puis reviens ici.',
    dbEmailSent: '✅ Email renvoyé !',
    dbResendEmail: 'Renvoyer l\'email',
    dbCheckedEmail: 'J\'ai vérifié mon email →',
    dbSignOut: 'Se déconnecter',
    dbCreateSection: '✨ Créer un nouveau parcours',
    dbCreateBtn: '➕ Nouveau parcours',
    dbCreateNotice: '💡 Ces paramètres sont obligatoires mais peuvent être modifiés à tout moment depuis les paramètres du parcours.',
    dbGamesSection: '🎮 Mes parcours',
    dbNoGames: 'Tu n\'as pas encore de parcours. Crée le tien !',
    dbUrlPlayers: 'URL joueurs :',
    dbEditGame: '✏️ Modifier',
    dbCloneGame: '🔀 Cloner',
    dbDeleteGame: '🗑️ Supprimer',
    dbCreating: 'Création…',
    dbCreateAndAdd: 'Créer et ajouter les points →',
    dbDeleteTitle: 'Supprimer le parcours ?',
    dbDeleteConfirmLabel: 'Tape le nom du parcours pour confirmer :',
    dbDeleting: 'Suppression…',
    dbDeletePermanently: 'Supprimer définitivement',
    dbCloneTitle: 'Cloner le parcours',
    dbNewCourseName: 'Nom du nouveau parcours *',
    dbCloning: 'Clonage…',
    dbCloneBtn: '🔀 Cloner le parcours',
    planLimitReached: 'Limite de parcours atteinte pour votre plan.',
    planUpgrade: 'Passer à un plan supérieur →',
    dbInfoDisplayName: 'Le nom affiché aux joueurs sur la page d\'accueil. Peut contenir des espaces et des accents.',
    dbInfoUrl: 'Identifiant unique dans l\'URL du joueur. Généré automatiquement depuis le nom, mais modifiable.',
    dbInfoLangs: 'Langues proposées aux joueurs. La première cochée sera la langue par défaut. Le contenu sera à renseigner pour chaque langue active.',
    dbInfoMap: 'Position centrale de la carte au démarrage. Ouvre Google Maps, fais un clic droit sur ton lieu de départ et copie les coordonnées.',
    dbInfoLastPoint: 'Numéro du point qui déclenche la fin du jeu. Correspond au dernier point créé dans l\'éditeur.',
    dbInfoVisitOrder: 'Liste des numéros de points dans l\'ordre de visite. Sépare par des virgules. Ex : 1, 2, 3, 4, 5.',

    // ── Wizard ───────────────────────────────────────────
    wizStep1Title: 'Étape 1 — Écran de navigation',
    wizStep1Hint: 'Choisissez ce que les joueurs verront à cette étape du parcours.',
    wizStep2Title: 'Étape 2 — Écran d\'information (optionnel)',
    wizStep2Hint: 'Sélectionnez un ou plusieurs types d\'information à afficher avant l\'exercice. Laissez vide pour passer directement à l\'exercice.',
    wizStep3Title: 'Étape 3 — Exercice',
    wizStep3Hint: 'Choisissez le type d\'exercice que les joueurs devront compléter à ce point.',
    wizNext: 'Suivant →',
    wizBack: '← Retour',
    wizSavePoint: '✅ Enregistrer le point',
    wizOptImageListName: 'Galerie d\'images',
    wizOptImageListDesc: 'Photo d\'un élément visible depuis cet endroit. Les joueurs doivent retrouver l\'emplacement.',
    wizOptDynamicMapDesc: 'Les joueurs naviguent sur une carte interactive pour atteindre ce point.',
    wizOptCarouselDesc: 'Plusieurs images défilent pour guider les joueurs jusqu\'à l\'endroit.',
    wizOptMissingWordDesc: 'Une pancarte visible depuis l\'endroit avec un mot caché que les joueurs retrouvent.',
    wizPhotoLabel: '📷 Photo du point',
    wizImageListHint: 'Choisissez une image de quelque chose que l\'on peut voir clairement depuis cet endroit (bâtiment, sculpture, panneau, etc.).',
    wizMissingWordImageHint: 'Uploadez la photo de la pancarte. Vous devrez indiquer ci-dessous le mot que vous y avez caché.',
    wizMapPositionLabel: '📍 Position sur la carte',
    wizPickOnMapBtn: '📍 Placer sur la carte',
    wizMissingWordFieldLabel: '🔤 Mot manquant',
    wizMissingWordFieldHint: 'Écrivez ici le mot que vous avez caché sur la pancarte.',
    wizMissingWordPlaceholder: 'Le mot caché...',
    wizOptNoInfoName: 'Pas d\'information',
    wizOptNoInfoDesc: 'Les joueurs passent directement à l\'exercice.',
    wizOptTextDesc: 'Un paragraphe d\'informations sur le lieu à lire.',
    wizOptAudioDesc: 'Un enregistrement audio lié à ce lieu.',
    wizOptVideoDesc: 'Une vidéo YouTube à regarder sur place.',
    wizOptARName: 'Réalité augmentée',
    wizOptARDesc: 'Un effet visuel AR superposé à la vue de la caméra.',
    wizOptPhoneName: 'Appel simulé',
    wizOptPhoneDesc: 'Un appel téléphonique simulé avec un message audio.',
    wizTextInfoLabel: '📝 Texte d\'information',
    wizTextInfoPlaceholder: 'Entrez le texte à afficher...',
    wizAudioLabel: '🎵 URL Audio',
    wizVideoLabel: '🎬 URL YouTube',
    wizCallerNameLabel: '📞 Nom de l\'appelant',
    wizOptQuestionsName: 'Questions',
    wizOptQuestionsDesc: 'Questions à choix multiples avec une bonne réponse.',
    wizOptPuzzleDesc: 'Les joueurs reconstituent une image en glissant des pièces.',
    wizOptMultipleMatchName: 'Association',
    wizOptMultipleMatchDesc: 'Les joueurs associent des images à des étiquettes.',
    wizOptMemoryDesc: 'Les joueurs retournent des cartes pour trouver les paires.',
    wizOptTrueFalseName: 'Juste / Faux',
    wizOptTrueFalseDesc: 'Les joueurs marquent chaque affirmation vraie ou fausse.',
    wizOptFillBlanksName: 'Texte à trous',
    wizOptFillBlanksDesc: 'Les joueurs complètent un texte avec les mots manquants.',
    wizOptRushHourDesc: 'Les joueurs déplacent des véhicules pour libérer un passage.',
    wizOptSignCardName: 'Panneau',
    wizOptSignCardDesc: 'Les joueurs identifient un mot sur un panneau ou une enseigne.',
    onboardingAlert: '✏️ Tout peut être modifié à tout moment par la suite — ne vous inquiétez pas !',
    settingsMapHint: 'C\'est ici que vous définissez le centre de la carte qui s\'affichera dans l\'application pour guider les joueurs. Cette information est obligatoire.',
    settingsPickOnMap: '📍 Choisir sur la carte',
    settingsCoordsUndefined: '⚠️ Coordonnées non définies — obligatoire',

    // ── Misc ──────────────────────────────────────────────
    loading: 'Chargement…',
    noRoute: 'Pas d\'itinéraire Google',
    gps: 'GPS :',
  },

  en: {
    // ── Auth ────────────────────────────────────────────
    adminTitle: 'Admin Panel',
    loginPromptGoogle: 'Sign in with your Google admin account',
    accessDenied: '❌ Access denied — this account is not authorized',
    connecting: 'Signing in…',
    signInGoogle: 'Sign in with Google',
    emailNotVerified: 'Email not verified',
    emailNotVerifiedMsg: 'Please verify your email before editing routes.',
    backToDashboard: 'Dashboard',
    editorTitle: 'Route Editor',
    loginPrompt: 'Sign in to access the editor.',
    loginError: '❌ Sign-in error',

    // ── Game selection ───────────────────────────────────
    chooseGame: 'Choose a route',
    createNew: '➕ Create new route',
    editExisting: '✏️ Edit existing route',
    newGameSettings: 'New route',
    newGameNotice: '💡 These settings are required but can be changed at any time in the settings.',
    gameName: 'Route name *',
    gameLabel: 'Route name',
    urlIdentifier: 'URL identifier *',
    urlNote: '(no spaces, no accents)',
    availableLanguages: 'Available languages *',
    langHebrew: '🇮🇱 Hebrew',
    langArabic: '🇸🇦 Arabic',
    langFrench: '🇫🇷 French',
    langEnglish: '🇬🇧 English',
    mapCenter: 'Map center (Lat / Lng) *',
    lastPointNumber: 'Last point number *',
    visitOrder: 'Visit order *',
    gameMode: 'Game mode *',
    modeGeographic: 'Geographic',
    modeGeographicDesc: 'Content tied to a physical location. Monuments, historical sites.',
    modeStory: 'Story',
    modeStoryDesc: 'Chapters in sequential order. Narrative, guided adventure.',
    startingLocation: 'Starting location (optional)',
    cancel: 'Cancel',
    createGame: 'Create route →',
    selectGame: 'Select a route',
    back: '← Back',
    logout: 'Logout',
    myGames: 'My routes',
    noGamesFound: 'No routes found.',

    // ── Topbar ───────────────────────────────────────────
    tabPoints: '📍 Points',
    tabSettings: '⚙️ Settings',
    adminLanguage: 'Interface language',

    // ── Points list ──────────────────────────────────────
    screen: 'Screen:',
    info: 'Info:',
    exercise: 'Exercise:',
    missingWord: 'Missing word:',
    save: '💾 Save',
    edit: '✏️ Edit',
    delete: '🗑️',
    noImage: 'No image',
    noPuzzleImage: 'No puzzle image',
    memoryUsesPointImages: '🃏 Point images are used as memory card pairs.',
    coordinates: '📍 Coordinates',
    lat: 'Lat',
    lng: 'Lng',
    pickOnMap: '📍 Pick on map',
    hideCoords: 'Hide lat/lng',
    showCoords: 'Show lat/lng',
    sectionScreen: '📱 Navigation screen',
    sectionInfo: 'ℹ️ Information screen',
    sectionExercise: '🎯 Exercise screen',
    missingWordReadLabel: '🔤 Missing word:',
    navOnly: '🧭 Navigation only',
    sectionPosition: '📍 Geographic position',
    positionDesc: 'Change the position of this point on the map.',
    sectionScreenHint: 'Choose how players navigate to this point.',
    sectionInfoHint: 'Add informational content shown before the exercise. This step is optional.',
    sectionExerciseHint: 'Choose the type of activity players must complete at this point.',
    sectionPositionHint: 'Set the GPS coordinates of this point on the map.',

    // ── Edit form — basic ─────────────────────────────────
    pointNumber: 'Point number',
    image: 'Image',
    changeImage: '🔄 Change image',
    chooseImage: '📁 Choose image',
    imageHint: '📸 Resized to 450 px. GPS extracted automatically if available.',
    navigationScreen: 'Navigation screen',
    screenImagesList: 'Images list',
    screenDynamicMap: 'Dynamic map',
    screenCarousel: 'Carousel',
    screenMissingWord: 'Missing word',
    missingWordLabel: 'Missing word (for sign search)',
    missingWordVisible: 'Word visible on the sign',
    pointInformation: 'Point information',
    labelText: 'Text',
    labelAudio: 'Audio',
    labelVideo: 'Video',
    labelAR: '📷 AR',
    labelPhone: '📞 Phone',
    waypoint: 'Waypoint',
    labelVideoId: '🎬 Video ID',
    noAudio: 'no audio',
    savePoint: '💾 Save point',
    imageUploadHint: '📸 Upload an image — GPS coordinates are extracted automatically if available',
    audioUrl: 'Audio URL',
    editPhoto: '✏️ Edit',

    // ── Phone ─────────────────────────────────────────────
    callerName: 'Caller name',
    callerNamePlaceholder: 'e.g. Inspector Cohen',
    phoneAudioUrl: 'Phone audio URL',

    // ── Video ─────────────────────────────────────────────
    youtubeUrl: 'YouTube URL or ID',
    shortsDetected: '📱 Shorts detected',
    youtubeWarning: '⚠️ Add a YouTube ID for the video to be visible.',

    // ── AR ────────────────────────────────────────────────
    arDirection: '🧭 Display direction',
    arPreset: 'Preset',
    arExactDeg: 'Exact degrees',
    arNorth: 'North (0°)',
    arNE: 'North-East (45°)',
    arEast: 'East (90°)',
    arSE: 'South-East (135°)',
    arSouth: 'South (180°)',
    arSW: 'South-West (225°)',
    arWest: 'West (270°)',
    arNW: 'North-West (315°)',
    arEffectUrl: 'Visual effect URL (.webm or .gif)',
    arSearchWord: 'Search word (optional)',
    arSearchWordPlaceholder: 'e.g. fountain, eagle, mural…',
    arSearchWordHint: 'If set, shows "Look for the [word]" on the AR screen.',
    arGifCount: 'Number of GIFs',
    arGif1: '1 (single)',
    arGif2: '2 (side by side)',
    arSpacing: 'Spacing (px)',
    arSpacingHint: 'Negative = overlap, positive = gap',
    arGrowAnimation: 'Image appearance',
    arGrow: '📈 Grow',
    arAppear: '⚡ Appear directly',
    rushHourTitle: '🚗 Rush Hour',

    // ── Exercise types ────────────────────────────────────
    exerciseType: 'Exercise type',
    exerciseQuestions: 'Questions',
    exercisePuzzle: 'Puzzle',
    exerciseMultipleMatch: 'Multiple match',
    exerciseMemory: '🃏 Memory',
    exerciseJusteFaux: '✅ True / False',
    exerciseMotManquant: '📝 Missing words',
    exerciseRushHour: '🚗 Rush Hour',
    exerciseSignCard: '🖊️ Card to sign',

    // ── Sign card ─────────────────────────────────────────
    signCardTitle: '🖊️ Card to sign',
    signCardImage: 'Card image',
    signCardZone: 'Signature zone',
    signCardHeight: 'Height:',
    signCardVAlign: 'Vertical position',
    signCardHAlign: 'Horizontal position',
    alignTop: 'Top',
    alignCenter: 'Center',
    alignBottom: 'Bottom',
    alignLeft: 'Left',
    alignRight: 'Right',

    // ── Puzzle ────────────────────────────────────────────
    puzzleImage: 'Puzzle image',
    puzzleImageHint: '🧩 Auto-cropped to square',

    // ── Memory ────────────────────────────────────────────
    memoryImages: '🃏 Custom images (optional, max 6)',
    memoryImagesHint: 'If none added, point images are used. Auto-resized to 120×120.',
    addImage: '📁 Add image',

    // ── Multiple match ────────────────────────────────────
    mmTitle: 'Pairs — 4 images + labels',
    mmHint: '🖼️ Images auto-cropped to 150×200',
    mmPair: 'Pair',
    mmLabel: 'Label',
    mmLabelPlaceholder: 'Word or phrase',

    // ── Mots manquants ────────────────────────────────────
    mmqHint: 'Wrap the words to find in curly braces: {word}',
    mmqPlaceholder: 'e.g. King {David} ruled over {Jerusalem} for {40} years.',
    mmqHoles: 'blank(s) detected',
    mmqMode: 'Mode',
    mmqVisible: '👀 Words visible',
    mmqHidden: '✏️ User types the answer',

    // ── Vrai / Faux ───────────────────────────────────────
    jfTitle: '✅ True / False',
    jfQuestion: 'Question',
    jfOptions: 'Options',
    jfOptionPlaceholder: 'Option…',
    jfAddOption: '+ Add option',
    jfQuestionPlaceholder: 'e.g. Which of these statements are true?',

    // ── Coordinates / Waypoints ───────────────────────────
    latitude: 'Latitude',
    longitude: 'Longitude',
    latitudePlaceholder: '32.657',
    longitudePlaceholder: '35.417',
    waypoints: 'Waypoints (optional)',
    addWaypoint: '+ Add waypoint',

    // ── Questions ─────────────────────────────────────────
    questionsTitle: '❓ Questions',
    correctAnswer: '✅ Correct answer',
    wrongAnswer1: '✗ Wrong answer 1',
    wrongAnswer2: '✗ Wrong answer 2',
    wrongAnswer3: '✗ Wrong answer 3',
    saveQuestion: '💾 Save',
    addQuestion: '➕ Add a question',
    newQuestion: 'New question',
    questionText: 'Question text *',
    linkedToPoint: 'Linked to point #',
    questionRequired: 'Question and correct answer are required.',

    // ── Add point buttons ─────────────────────────────────
    addPoint: 'Add a point',
    addNavPoint: '🧭 Add a navigation point',
    newPoint: 'New point',
    newNavPoint: '🧭 New navigation point',
    points: 'points',
    planPointsLimit: 'Your current plan is limited to {max} points. To add more, upgrade to a higher plan.',
    pointAdded: '✅ Point added',
    navPointInfo: 'A navigation point has no exercise or information screen. It only guides the player to a location.',
    pointNumberRequired: 'Point number *',
    pointInformationText: 'Information text',
    requiredFields: 'Point number, latitude and longitude are required.',
    pointExists: 'This point already exists.',
    infoRequired: 'At least one info field is required: audio, text, video, AR or phone.',
    imageRequired: 'An image is required.',

    // ── Settings — Map ────────────────────────────────────
    settingsMap: '🗺️ Map parameters',
    centerLat: 'Center latitude',
    centerLng: 'Center longitude',
    zoom: 'Zoom',
    saveMap: '💾 Save map',

    // ── Settings — Display name ───────────────────────────
    displayName: '🏷️ Display name (shown to players)',
    displayNameHint: 'This name appears on the player home page. Can include spaces and accents.',
    saveDisplayName: '💾 Save name',

    // ── Settings — Starting location ──────────────────────
    settingsStartLocation: '📍 Starting location',
    startLocationHint: 'If set, the home page shows "Head to: [name]" instead of the default Waze phrase.',
    startLocationPlaceholder: 'e.g. Main Square, Town Hall Parking…',
    saveStartLocation: '💾 Save',

    // ── Settings — Last point ─────────────────────────────
    settingsLastPoint: '🏁 Last point (end of game)',
    lastPointHint: 'Point number that ends the route. This point is shown in red on the map.',
    lastPointPlaceholder: 'Last point number',
    saveLastPoint: '💾 Save',

    // ── Settings — Visit orders ───────────────────────────
    settingsOrders: '🔀 Visit orders',
    ordersHint: 'Each order is a comma-separated list of point numbers. One is randomly assigned to each player at start.',
    noOrders: 'No orders defined.',
    order: 'Order',
    addOrder: '+ New order',
    saveOrders: '💾 Save orders',

    // ── Settings — URL ────────────────────────────────────
    gameUrl: '🔗 Route URL',
    copy: '📋 Copy',

    // ── Settings — Game options ───────────────────────────
    settingsOptions: '⚙️ Game options',
    randomQuestions: 'Random questions',
    settingsMode: 'Route mode',
    modeGeographicFull: 'Geographic — content tied to physical location. Ideal for monuments, historical sites.',
    modeStoryFull: 'Story — told in sequential order. Ideal for narrative, guided adventure.',
    emptyPoints: '⚠️ Points without content in Geographic mode:',
    emptyPointsHint: 'These points have no information or exercise. The player will advance automatically.',
    saveMode: '💾 Save mode',

    // ── Settings — Languages ──────────────────────────────
    settingsLangs: '🌍 Available languages',
    langsHint: 'Choose the languages offered to players. The first checked will be the default language.',
    saveLangs: '💾 Save languages',

    // ── Settings — Background image ───────────────────────
    bgImage: '🖼️ Home page background image',
    bgImageHint: 'This image appears as the background when players land on your route.',
    saveBgImage: '💾 Save image',
    saving: '⏳ Saving…',

    // ── Delete confirmation ───────────────────────────────
    deleteTitle: 'Delete point',
    deleteMsg: 'This action is irreversible. The point and its images will be permanently deleted from all languages.',
    confirmDelete: 'Delete',
    deleting: 'Deleting…',

    // ── Map picker ────────────────────────────────────────
    mapPickerHint: '📍 Click on the map to set coordinates',
    confirm: 'Confirm',

    // ── Toast messages ────────────────────────────────────
    toastPointSaved: 'Point saved!',
    toastPointCreated: 'Point created!',
    toastPointDeleted: 'Point deleted!',
    toastQuestionSaved: 'Question saved!',
    toastQuestionCreated: 'Question created!',
    toastDisplayNameSaved: 'Display name saved!',
    toastStartLocationSaved: 'Starting location saved!',
    toastMapSaved: 'Map saved!',
    toastLastPointSaved: 'Last point saved!',
    toastOrdersSaved: 'Orders saved!',
    toastOrderDeleted: 'Order deleted!',
    toastUrlCopied: 'URL copied!',
    toastBgImageSaved: 'Background image saved!',
    toastBgImageError: 'Error saving the image.',
    toastGameCreated: 'Route created!',
    toastNavPointCreated: 'Navigation point created!',
    toastLangsSaved: 'Languages saved!',

    // ── Story mode explanation ────────────────────────────
    storyModeTitle: '📖 Story mode — how it works',
    storyModeDesc: 'In Story mode, content is shown in point number order (1, 2, 3…), regardless of GPS navigation order.',
    storyModeEdit: 'To edit content, edit each point normally in the Points tab.',

    // ── Field worker link (admin side) ────────────────────
    fieldLinkTitle: '🧭 Field link (photo + GPS)',
    fieldLinkHint: 'Generate a link to send to the person who will photograph the points and record GPS coordinates. The page is blank — it does not show existing data.',
    fieldLinkGenerating: '⏳ Generating…',
    fieldLinkGenerate: '🔗 Generate field link',
    fieldLinkCopied: 'Link copied!',

    // ── Field worker page ─────────────────────────────────
    fwLoading: 'Loading…',
    fwInvalidTitle: 'Invalid link',
    fwInvalidMsg: 'This link has expired or is incorrect. Ask the administrator for a new link.',
    fwPointsToFill: 'point(s) to fill in',
    fwTutoPhotoTitle: 'Photo',
    fwTutoPhotoBody: 'Take a photo of something clearly visible from this point — a sign, a building, a monument. This photo will be shown to players.',
    fwTutoGpsTitle: 'GPS Coordinates',
    fwTutoGpsBody: 'Stand exactly at the point location and enter your GPS coordinates. In Google Maps, long-press on your position → the coordinates appear at the bottom.',
    fwTutoSaveTitle: 'Save',
    fwTutoSaveBody: 'Each point saves independently. You can do them in any order and come back to this link later.',
    fwStart: 'Start →',
    fwSavedCount: 'saved',
    fwDoneTag: '✅ Saved',
    fwTodoTag: 'To fill in',
    fwPhotoLabel: '📸 Photo',
    fwPhotoHint: 'Something clearly visible from this point (sign, building, monument…)',
    fwChoosePhoto: '📁 Choose a photo',
    fwGpsLabel: '📍 GPS Coordinates',
    fwGpsHint: 'In Google Maps: long-press your position → copy the coordinates shown at the bottom.',
    fwLatPlaceholder: 'Latitude  e.g. 32.657',
    fwLngPlaceholder: 'Longitude  e.g. 35.417',
    fwSaving: '⏳ Saving…',
    fwModify: '🔄 Edit',
    fwSavePoint: '💾 Save this point',
    fwSaveError: 'Error saving. Please try again.',
    fwAllDone: '🎉 All points have been filled in! The administrator can now finalize the route.',
    fwToastSaved: 'Point saved ✅',
    fwPickOnMap: 'Pick on map',

    // ── Dashboard ─────────────────────────────────────────
    dbTitle: 'My Eifoany Space',
    dbLoginDesc: 'Sign in with Google to access your creator space',
    dbAuthError: '❌ Sign-in error, please try again.',
    dbVerifyEmail: 'Verify your email',
    dbVerifyEmailMsg: 'A verification email has been sent. Click the link then come back here.',
    dbEmailSent: '✅ Email resent!',
    dbResendEmail: 'Resend email',
    dbCheckedEmail: 'I verified my email →',
    dbSignOut: 'Sign out',
    dbCreateSection: '✨ Create a new route',
    dbCreateBtn: '➕ New route',
    dbCreateNotice: '💡 These settings are required but can be changed at any time from the route settings.',
    dbGamesSection: '🎮 My routes',
    dbNoGames: 'You have no routes yet. Create your first one!',
    dbUrlPlayers: 'Player URL:',
    dbEditGame: '✏️ Edit',
    dbCloneGame: '🔀 Clone',
    dbDeleteGame: '🗑️ Delete',
    dbCreating: 'Creating…',
    dbCreateAndAdd: 'Create and add points →',
    dbDeleteTitle: 'Delete route?',
    dbDeleteConfirmLabel: 'Type the route name to confirm:',
    dbDeleting: 'Deleting…',
    dbDeletePermanently: 'Delete permanently',
    dbCloneTitle: 'Clone route',
    dbNewCourseName: 'New route name *',
    dbCloning: 'Cloning…',
    dbCloneBtn: '🔀 Clone route',
    planLimitReached: 'Route limit reached for your plan.',
    planUpgrade: 'Upgrade your plan →',
    dbInfoDisplayName: 'The name shown to players on the home page. Can include spaces and accents.',
    dbInfoUrl: 'Unique identifier in the player URL. Auto-generated from the name, but editable.',
    dbInfoLangs: 'Languages offered to players. The first checked will be the default. Content must be filled in for each active language.',
    dbInfoMap: 'Map center position at game start. Open Google Maps, right-click your starting location and copy the coordinates.',
    dbInfoLastPoint: 'Point number that triggers the end of the game. Corresponds to the last point created in the editor.',
    dbInfoVisitOrder: 'List of point numbers in visit order. Separate with commas. Ex: 1, 2, 3, 4, 5.',

    // ── Wizard ───────────────────────────────────────────
    wizStep1Title: 'Step 1 — Navigation screen',
    wizStep1Hint: 'Choose what players will see at this point in the route.',
    wizStep2Title: 'Step 2 — Information screen (optional)',
    wizStep2Hint: 'Select one or more information types to show before the exercise. Leave empty to go straight to the exercise.',
    wizStep3Title: 'Step 3 — Exercise',
    wizStep3Hint: 'Choose the type of exercise players will need to complete at this point.',
    wizNext: 'Next →',
    wizBack: '← Back',
    wizSavePoint: '✅ Save point',
    wizOptImageListName: 'Image gallery',
    wizOptImageListDesc: 'Photo of something visible from this location. Players must find the spot.',
    wizOptDynamicMapDesc: 'Players navigate on an interactive map to reach this point.',
    wizOptCarouselDesc: 'Multiple images scroll to guide players to the location.',
    wizOptMissingWordDesc: 'A sign visible from the location with a hidden word that players must find.',
    wizPhotoLabel: '📷 Point photo',
    wizImageListHint: 'Choose an image of something clearly visible from this location (building, sculpture, sign, etc.).',
    wizMissingWordImageHint: 'Upload the photo of the sign. You will need to indicate below the word you have hidden on it.',
    wizMapPositionLabel: '📍 Position on map',
    wizPickOnMapBtn: '📍 Place on map',
    wizMissingWordFieldLabel: '🔤 Missing word',
    wizMissingWordFieldHint: 'Write here the word you have hidden on the sign.',
    wizMissingWordPlaceholder: 'The hidden word...',
    wizOptNoInfoName: 'No information',
    wizOptNoInfoDesc: 'Players go directly to the exercise.',
    wizOptTextDesc: 'A paragraph of information about the location to read.',
    wizOptAudioDesc: 'An audio recording linked to this location.',
    wizOptVideoDesc: 'A YouTube video to watch on location.',
    wizOptARName: 'Augmented reality',
    wizOptARDesc: 'An AR visual effect overlaid on the camera view.',
    wizOptPhoneName: 'Simulated call',
    wizOptPhoneDesc: 'A simulated phone call with an audio message.',
    wizTextInfoLabel: '📝 Information text',
    wizTextInfoPlaceholder: 'Enter the text to display...',
    wizAudioLabel: '🎵 Audio URL',
    wizVideoLabel: '🎬 YouTube URL',
    wizCallerNameLabel: '📞 Caller name',
    wizOptQuestionsName: 'Questions',
    wizOptQuestionsDesc: 'Multiple choice questions with one correct answer.',
    wizOptPuzzleDesc: 'Players reassemble an image by sliding pieces.',
    wizOptMultipleMatchName: 'Matching',
    wizOptMultipleMatchDesc: 'Players match images to labels.',
    wizOptMemoryDesc: 'Players flip cards to find matching pairs.',
    wizOptTrueFalseName: 'True / False',
    wizOptTrueFalseDesc: 'Players mark each statement as true or false.',
    wizOptFillBlanksName: 'Fill in the blanks',
    wizOptFillBlanksDesc: 'Players complete a text with missing words.',
    wizOptRushHourDesc: 'Players move vehicles to clear a path.',
    wizOptSignCardName: 'Sign card',
    wizOptSignCardDesc: 'Players identify a word on a sign or signboard.',
    onboardingAlert: '✏️ Everything can be changed at any time later — don\'t worry!',
    settingsMapHint: 'This is where you set the center of the map that will be displayed in the app to guide players. This information is required.',
    settingsPickOnMap: '📍 Choose on map',
    settingsCoordsUndefined: '⚠️ Coordinates not set — required',

    // ── Misc ──────────────────────────────────────────────
    loading: 'Loading…',
    noRoute: 'No Google route',
    gps: 'GPS:',
  },

  he: {
    // ── Auth ────────────────────────────────────────────
    adminTitle: 'פאנל ניהול',
    loginPromptGoogle: 'התחבר עם חשבון Google של המנהל',
    accessDenied: '❌ גישה נדחתה — חשבון זה אינו מורשה',
    connecting: 'מתחבר…',
    signInGoogle: 'התחברות עם Google',
    emailNotVerified: 'אימייל לא אומת',
    emailNotVerifiedMsg: 'אמת את האימייל שלך לפני עריכת מסלולים.',
    backToDashboard: 'לוח הבקרה',
    editorTitle: 'עורך מסלולים',
    loginPrompt: 'התחבר כדי לגשת לעורך.',
    loginError: '❌ שגיאת התחברות',

    // ── Game selection ───────────────────────────────────
    chooseGame: 'בחר מסלול',
    createNew: '➕ צור מסלול חדש',
    editExisting: '✏️ ערוך מסלול קיים',
    newGameSettings: 'מסלול חדש',
    newGameNotice: '💡 הגדרות אלו נדרשות אך ניתן לשנותן בכל עת בהגדרות.',
    gameName: 'שם המסלול *',
    gameLabel: 'שם המסלול',
    urlIdentifier: 'מזהה URL *',
    urlNote: '(ללא רווחים או תווים מיוחדים)',
    availableLanguages: 'שפות זמינות *',
    langHebrew: '🇮🇱 עברית',
    langArabic: '🇸🇦 ערבית',
    langFrench: '🇫🇷 צרפתית',
    langEnglish: '🇬🇧 אנגלית',
    mapCenter: 'מרכז המפה (קו רוחב / קו אורך) *',
    lastPointNumber: 'מספר הנקודה האחרונה *',
    visitOrder: 'סדר ביקור *',
    gameMode: 'מצב משחק *',
    modeGeographic: 'גיאוגרפי',
    modeGeographicDesc: 'תוכן קשור למיקום פיזי. אנדרטאות, אתרים היסטוריים.',
    modeStory: 'סיפור',
    modeStoryDesc: 'פרקים בסדר רצף. נרטיב, הרפתקה מודרכת.',
    startingLocation: 'מיקום התחלתי (אופציונלי)',
    cancel: 'ביטול',
    createGame: 'צור מסלול →',
    selectGame: 'בחר מסלול',
    back: '→ חזרה',
    logout: 'התנתקות',
    myGames: 'המסלולים שלי',
    noGamesFound: 'לא נמצאו מסלולים.',

    // ── Topbar ───────────────────────────────────────────
    tabPoints: '📍 נקודות',
    tabSettings: '⚙️ הגדרות',
    adminLanguage: 'שפת הממשק',

    // ── Points list ──────────────────────────────────────
    screen: 'מסך:',
    info: 'מידע:',
    exercise: 'תרגיל:',
    missingWord: 'מילה חסרה:',
    save: '💾 שמור',
    edit: '✏️ ערוך',
    delete: '🗑️',
    noImage: 'אין תמונה',
    noPuzzleImage: 'אין תמונת פאזל',
    memoryUsesPointImages: '🃏 תמונות הנקודה משמשות כזוגות קלפי זיכרון.',
    coordinates: '📍 קואורדינטות',
    lat: 'רוחב',
    lng: 'אורך',
    pickOnMap: '📍 בחר על המפה',
    hideCoords: 'הסתר קואורדינטות',
    showCoords: 'הצג קואורדינטות',
    sectionScreen: '📱 מסך ניווט',
    sectionInfo: 'ℹ️ מסך מידע',
    sectionExercise: '🎯 מסך תרגיל',
    missingWordReadLabel: '🔤 מילה חסרה:',
    navOnly: '🧭 ניווט בלבד',
    sectionPosition: '📍 מיקום גיאוגרפי',
    positionDesc: 'שנו את מיקום הנקודה על המפה.',
    sectionScreenHint: 'בחרו כיצד השחקנים מנווטים לנקודה זו.',
    sectionInfoHint: 'הוסיפו תוכן מידע המוצג לפני התרגיל. שלב זה הוא אופציונלי.',
    sectionExerciseHint: 'בחרו את סוג הפעילות שהשחקנים צריכים להשלים בנקודה זו.',
    sectionPositionHint: 'הגדירו את קואורדינטות ה-GPS של נקודה זו על המפה.',

    // ── Edit form — basic ─────────────────────────────────
    pointNumber: 'מספר נקודה',
    image: 'תמונה',
    changeImage: '🔄 שנה תמונה',
    chooseImage: '📁 בחר תמונה',
    imageHint: '📸 מוקטנת ל-450px. GPS נשלף אוטומטית אם זמין.',
    navigationScreen: 'מסך ניווט',
    screenImagesList: 'רשימת תמונות',
    screenDynamicMap: 'מפה דינמית',
    screenCarousel: 'קרוסלה',
    screenMissingWord: 'מילה חסרה',
    missingWordLabel: 'מילה חסרה (לחיפוש שלט)',
    missingWordVisible: 'מילה גלויה על השלט',
    pointInformation: 'מידע על הנקודה',
    labelText: 'טקסט',
    labelAudio: 'שמע',
    labelVideo: 'וידאו',
    labelAR: '📷 מציאות רבודה',
    labelPhone: '📞 טלפון',
    waypoint: 'נקודת ביניים',
    labelVideoId: '🎬 מזהה וידאו',
    noAudio: 'ללא שמע',
    savePoint: '💾 שמור נקודה',
    imageUploadHint: '📸 העלה תמונה — קואורדינטות GPS נשלפות אוטומטית אם זמינות.',
    audioUrl: 'URL שמע',
    editPhoto: '✏️ ערוך',

    // ── Phone ─────────────────────────────────────────────
    callerName: 'שם המתקשר',
    callerNamePlaceholder: 'לדוג. פקח כהן',
    phoneAudioUrl: 'URL שמע של השיחה',

    // ── Video ─────────────────────────────────────────────
    youtubeUrl: 'URL או מזהה YouTube',
    shortsDetected: '📱 Shorts זוהה',
    youtubeWarning: '⚠️ הוסף מזהה YouTube כדי שהוידאו יהיה גלוי.',

    // ── AR ────────────────────────────────────────────────
    arDirection: '🧭 כיוון תצוגה',
    arPreset: 'מוגדר מראש',
    arExactDeg: 'מעלות מדויקות',
    arNorth: 'צפון (0°)',
    arNE: 'צפון-מזרח (45°)',
    arEast: 'מזרח (90°)',
    arSE: 'דרום-מזרח (135°)',
    arSouth: 'דרום (180°)',
    arSW: 'דרום-מערב (225°)',
    arWest: 'מערב (270°)',
    arNW: 'צפון-מערב (315°)',
    arEffectUrl: 'URL אפקט ויזואלי (.webm או .gif)',
    arSearchWord: 'מילת חיפוש (אופציונלי)',
    arSearchWordPlaceholder: 'לדוג. מזרקה, נשר, ציורית…',
    arSearchWordHint: 'אם הוזן, יציג "חפשו את [המילה]" במסך ה-AR.',
    arGifCount: 'מספר GIF',
    arGif1: '1 (בודד)',
    arGif2: '2 (זה לצד זה)',
    arSpacing: 'ריווח (px)',
    arSpacingHint: 'שלילי = חפיפה, חיובי = רווח',
    arGrowAnimation: 'הופעת התמונה',
    arGrow: '📈 גדל',
    arAppear: '⚡ מופיע ישירות',
    rushHourTitle: '🚗 Rush Hour',

    // ── Exercise types ────────────────────────────────────
    exerciseType: 'סוג תרגיל',
    exerciseQuestions: 'שאלות',
    exercisePuzzle: 'פאזל',
    exerciseMultipleMatch: 'התאמת זוגות',
    exerciseMemory: '🃏 זיכרון',
    exerciseJusteFaux: '✅ נכון / לא נכון',
    exerciseMotManquant: '📝 מילים חסרות',
    exerciseRushHour: '🚗 Rush Hour',
    exerciseSignCard: '🖊️ כרטיס לחתימה',

    // ── Sign card ─────────────────────────────────────────
    signCardTitle: '🖊️ כרטיס לחתימה',
    signCardImage: 'תמונת הכרטיס',
    signCardZone: 'אזור חתימה',
    signCardHeight: 'גובה:',
    signCardVAlign: 'מיקום אנכי',
    signCardHAlign: 'מיקום אופקי',
    alignTop: 'למעלה',
    alignCenter: 'מרכז',
    alignBottom: 'למטה',
    alignLeft: 'שמאל',
    alignRight: 'ימין',

    // ── Puzzle ────────────────────────────────────────────
    puzzleImage: 'תמונת פאזל',
    puzzleImageHint: '🧩 נחתכת אוטומטית לריבוע',

    // ── Memory ────────────────────────────────────────────
    memoryImages: '🃏 תמונות מותאמות אישית (אופציונלי, עד 6)',
    memoryImagesHint: 'אם לא הוספת תמונות, תמונות הנקודה ישמשו. מוקטנות ל-120×120.',
    addImage: '📁 הוסף תמונה',

    // ── Multiple match ────────────────────────────────────
    mmTitle: 'זוגות — 4 תמונות + תוויות',
    mmHint: '🖼️ תמונות נחתכות אוטומטית ל-150×200',
    mmPair: 'זוג',
    mmLabel: 'תווית',
    mmLabelPlaceholder: 'מילה או משפט',

    // ── Mots manquants ────────────────────────────────────
    mmqHint: 'הקף את המילים למציאה בסוגריים מסולסלים: {מילה}',
    mmqPlaceholder: 'לדוג. המלך {דוד} שלט ב{ירושלים} במשך {40} שנים.',
    mmqHoles: 'חלל/חללים זוהו',
    mmqMode: 'מצב',
    mmqVisible: '👀 מילים גלויות',
    mmqHidden: '✏️ המשתמש מקליד',

    // ── Vrai / Faux ───────────────────────────────────────
    jfTitle: '✅ נכון / לא נכון',
    jfQuestion: 'שאלה',
    jfOptions: 'אפשרויות',
    jfOptionPlaceholder: 'אפשרות…',
    jfAddOption: '+ הוסף אפשרות',
    jfQuestionPlaceholder: 'לדוג. אילו מהאמירות הבאות נכונות?',

    // ── Coordinates / Waypoints ───────────────────────────
    latitude: 'קו רוחב',
    longitude: 'קו אורך',
    latitudePlaceholder: '32.657',
    longitudePlaceholder: '35.417',
    waypoints: 'נקודות ביניים (אופציונלי)',
    addWaypoint: '+ הוסף נקודת ביניים',

    // ── Questions ─────────────────────────────────────────
    questionsTitle: '❓ שאלות',
    correctAnswer: '✅ תשובה נכונה',
    wrongAnswer1: '✗ תשובה שגויה 1',
    wrongAnswer2: '✗ תשובה שגויה 2',
    wrongAnswer3: '✗ תשובה שגויה 3',
    saveQuestion: '💾 שמור',
    addQuestion: '➕ הוסף שאלה',
    newQuestion: 'שאלה חדשה',
    questionText: 'טקסט השאלה *',
    linkedToPoint: 'מקושר לנקודה #',
    questionRequired: 'שאלה ותשובה נכונה הם שדות חובה.',

    // ── Add point buttons ─────────────────────────────────
    addPoint: 'הוסף נקודה',
    addNavPoint: '🧭 הוסף נקודת ניווט',
    newPoint: 'נקודה חדשה',
    newNavPoint: '🧭 נקודת ניווט חדשה',
    points: 'נקודות',
    planPointsLimit: 'התוכנית הנוכחית מוגבלת ל-{max} נקודות. להוספת עוד נקודות, שדרג לתוכנית גבוהה יותר.',
    pointAdded: '✅ נקודה נוספה',
    navPointInfo: 'נקודת ניווט אינה כוללת תרגיל או מסך מידע. היא משמשת אך ורק להנחיית השחקן.',
    pointNumberRequired: 'מספר נקודה *',
    pointInformationText: 'טקסט מידע',
    requiredFields: 'מספר נקודה, קו רוחב וקו אורך הם שדות חובה.',
    pointExists: 'נקודה זו כבר קיימת.',
    infoRequired: 'לפחות שדה אחד נדרש: שמע, טקסט, וידאו, AR או טלפון.',
    imageRequired: 'תמונה נדרשת.',

    // ── Settings — Map ────────────────────────────────────
    settingsMap: '🗺️ פרמטרי מפה',
    centerLat: 'קו רוחב מרכז',
    centerLng: 'קו אורך מרכז',
    zoom: 'זום',
    saveMap: '💾 שמור מפה',

    // ── Settings — Display name ───────────────────────────
    displayName: '🏷️ שם תצוגה (גלוי לשחקנים)',
    displayNameHint: 'שם זה מופיע בדף הבית של השחקנים. יכול לכלול רווחים ואותיות מיוחדות.',
    saveDisplayName: '💾 שמור שם',

    // ── Settings — Starting location ──────────────────────
    settingsStartLocation: '📍 מיקום התחלתי',
    startLocationHint: 'אם הוזן, דף הבית יציג "הגיעו אל: [שם]" במקום הביטוי הרגיל.',
    startLocationPlaceholder: 'לדוג. כיכר העיר, חניון העירייה…',
    saveStartLocation: '💾 שמור',

    // ── Settings — Last point ─────────────────────────────
    settingsLastPoint: '🏁 נקודה אחרונה (סוף המשחק)',
    lastPointHint: 'מספר הנקודה שמסיימת את המסלול. נקודה זו מוצגת באדום על המפה.',
    lastPointPlaceholder: 'מספר הנקודה האחרונה',
    saveLastPoint: '💾 שמור',

    // ── Settings — Visit orders ───────────────────────────
    settingsOrders: '🔀 סדרי ביקור',
    ordersHint: 'כל סדר הוא רשימת מספרי נקודות מופרדים בפסיקים. סדר אחד מוקצה אקראית לכל שחקן.',
    noOrders: 'לא הוגדרו סדרים.',
    order: 'סדר',
    addOrder: '+ סדר חדש',
    saveOrders: '💾 שמור סדרים',

    // ── Settings — URL ────────────────────────────────────
    gameUrl: '🔗 URL המסלול',
    copy: '📋 העתק',

    // ── Settings — Game options ───────────────────────────
    settingsOptions: '⚙️ אפשרויות משחק',
    randomQuestions: 'שאלות אקראיות',
    settingsMode: 'מצב המסלול',
    modeGeographicFull: 'גיאוגרפי — תוכן קשור למיקום פיזי. מתאים לאנדרטאות ואתרים היסטוריים.',
    modeStoryFull: 'סיפור — מסופר בסדר רצף. מתאים לנרטיב ולהרפתקה מודרכת.',
    emptyPoints: '⚠️ נקודות ללא תוכן במצב גיאוגרפי:',
    emptyPointsHint: 'לנקודות אלה אין מידע ולא תרגיל. השחקן יתקדם אוטומטית.',
    saveMode: '💾 שמור מצב',

    // ── Settings — Languages ──────────────────────────────
    settingsLangs: '🌍 שפות זמינות',
    langsHint: 'בחר את השפות שיוצעו לשחקנים. הראשונה שמסומנת תהיה ברירת המחדל.',
    saveLangs: '💾 שמור שפות',

    // ── Settings — Background image ───────────────────────
    bgImage: '🖼️ תמונת רקע לדף הבית',
    bgImageHint: 'תמונה זו מופיעה ברקע כאשר שחקנים מגיעים למסלול.',
    saveBgImage: '💾 שמור תמונה',
    saving: '⏳ שומר…',

    // ── Delete confirmation ───────────────────────────────
    deleteTitle: 'מחק נקודה',
    deleteMsg: 'פעולה זו אינה ניתנת לביטול. הנקודה ותמונותיה יימחקו לצמיתות מכל השפות.',
    confirmDelete: 'מחק',
    deleting: 'מוחק…',

    // ── Map picker ────────────────────────────────────────
    mapPickerHint: '📍 לחץ על המפה לבחירת מיקום',
    confirm: 'אישור',

    // ── Toast messages ────────────────────────────────────
    toastPointSaved: '!נקודה נשמרה',
    toastPointCreated: '!נקודה נוצרה',
    toastPointDeleted: '!נקודה נמחקה',
    toastQuestionSaved: '!שאלה נשמרה',
    toastQuestionCreated: '!שאלה נוצרה',
    toastDisplayNameSaved: '!שם התצוגה נשמר',
    toastStartLocationSaved: '!מיקום ההתחלה נשמר',
    toastMapSaved: '!המפה נשמרה',
    toastLastPointSaved: '!הנקודה האחרונה נשמרה',
    toastOrdersSaved: '!סדרים נשמרו',
    toastOrderDeleted: '!סדר נמחק',
    toastUrlCopied: '!URL הועתק',
    toastBgImageSaved: '!תמונת הרקע נשמרה',
    toastBgImageError: '.שגיאה בשמירת התמונה',
    toastGameCreated: '!מסלול נוצר',
    toastNavPointCreated: '!נקודת ניווט נוצרה',
    toastLangsSaved: '!שפות נשמרו',

    // ── Story mode explanation ────────────────────────────
    storyModeTitle: '📖 מצב סיפור — כיצד זה עובד',
    storyModeDesc: 'במצב סיפור, תוכן מוצג לפי סדר מספרי הנקודות (1, 2, 3…), ללא קשר לסדר הניווט ה-GPS.',
    storyModeEdit: 'לעריכת תוכן, ערוך כל נקודה כרגיל בכרטיסיית הנקודות.',

    // ── Field worker link (admin side) ────────────────────
    fieldLinkTitle: '🧭 קישור שטח (תמונה + GPS)',
    fieldLinkHint: 'צור קישור לשליחה לאדם שיצלם את הנקודות וירשום קואורדינטות GPS. הדף ריק — הוא לא מציג נתונים קיימים.',
    fieldLinkGenerating: '⏳ יוצר…',
    fieldLinkGenerate: '🔗 צור קישור שטח',
    fieldLinkCopied: 'קישור הועתק!',

    // ── Field worker page ─────────────────────────────────
    fwLoading: 'טוען…',
    fwInvalidTitle: 'קישור לא תקין',
    fwInvalidMsg: 'הקישור פג תוקף או שגוי. בקש קישור חדש מהמנהל.',
    fwPointsToFill: 'נקודות למילוי',
    fwTutoPhotoTitle: 'תמונה',
    fwTutoPhotoBody: 'צלם משהו שנראה בבירור מנקודה זו — שלט, בניין, אנדרטה. תמונה זו תוצג לשחקנים.',
    fwTutoGpsTitle: 'קואורדינטות GPS',
    fwTutoGpsBody: 'עמוד בדיוק במיקום הנקודה והזן את קואורדינטות ה-GPS שלך. ב-Google Maps, לחץ לחיצה ארוכה על המיקום שלך → הקואורדינטות מופיעות בתחתית.',
    fwTutoSaveTitle: 'שמירה',
    fwTutoSaveBody: 'כל נקודה נשמרת בנפרד. אתה יכול לעשות אותן בכל סדר ולחזור לקישור הזה מאוחר יותר.',
    fwStart: 'התחל →',
    fwSavedCount: 'נשמרו',
    fwDoneTag: '✅ נשמר',
    fwTodoTag: 'ממתין למילוי',
    fwPhotoLabel: '📸 תמונה',
    fwPhotoHint: 'משהו שנראה בבירור מנקודה זו (שלט, בניין, אנדרטה…)',
    fwChoosePhoto: '📁 בחר תמונה',
    fwGpsLabel: '📍 קואורדינטות GPS',
    fwGpsHint: 'ב-Google Maps: לחץ לחיצה ארוכה על המיקום שלך → העתק את הקואורדינטות שמופיעות בתחתית.',
    fwLatPlaceholder: 'קו רוחב  לדוג. 32.657',
    fwLngPlaceholder: 'קו אורך  לדוג. 35.417',
    fwSaving: '⏳ שומר…',
    fwModify: '🔄 ערוך',
    fwSavePoint: '💾 שמור נקודה זו',
    fwSaveError: 'שגיאה בשמירה. נסה שוב.',
    fwAllDone: '🎉 כל הנקודות מולאו! המנהל יכול כעת לסיים את המסלול.',
    fwToastSaved: 'נקודה נשמרה ✅',
    fwPickOnMap: 'בחר על המפה',

    // ── Dashboard ─────────────────────────────────────────
    dbTitle: 'המרחב שלי ב-Eifoany',
    dbLoginDesc: 'התחבר עם Google כדי לגשת לאזור היצירה שלך',
    dbAuthError: '❌ שגיאת התחברות, נסה שוב.',
    dbVerifyEmail: 'אמת את האימייל שלך',
    dbVerifyEmailMsg: 'נשלח אימייל אימות. לחץ על הקישור ואז חזור לכאן.',
    dbEmailSent: '✅ אימייל נשלח שוב!',
    dbResendEmail: 'שלח אימייל שוב',
    dbCheckedEmail: 'אימתתי את האימייל שלי →',
    dbSignOut: 'התנתקות',
    dbCreateSection: '✨ צור מסלול חדש',
    dbCreateBtn: '➕ מסלול חדש',
    dbCreateNotice: '💡 הגדרות אלו נדרשות אך ניתן לשנותן בכל עת מהגדרות המסלול.',
    dbGamesSection: '🎮 המסלולים שלי',
    dbNoGames: 'עדיין אין לך מסלולים. צור את הראשון שלך!',
    dbUrlPlayers: 'URL שחקנים:',
    dbEditGame: '✏️ ערוך',
    dbCloneGame: '🔀 שכפל',
    dbDeleteGame: '🗑️ מחק',
    dbCreating: 'יוצר…',
    dbCreateAndAdd: 'צור והוסף נקודות →',
    dbDeleteTitle: 'מחק מסלול?',
    dbDeleteConfirmLabel: 'הקלד את שם המסלול לאישור:',
    dbDeleting: 'מוחק…',
    dbDeletePermanently: 'מחק לצמיתות',
    dbCloneTitle: 'שכפל מסלול',
    dbNewCourseName: 'שם המסלול החדש *',
    dbCloning: 'משכפל…',
    dbCloneBtn: '🔀 שכפל מסלול',
    planLimitReached: 'הגעת למגבלת המסלולים בתוכנית שלך.',
    planUpgrade: 'שדרג תוכנית →',
    dbInfoDisplayName: 'השם שמוצג לשחקנים בדף הבית. יכול לכלול רווחים ואותיות מיוחדות.',
    dbInfoUrl: 'מזהה ייחודי ב-URL של השחקן. נוצר אוטומטית מהשם, אך ניתן לעריכה.',
    dbInfoLangs: 'שפות שמוצעות לשחקנים. הראשונה שמסומנת תהיה ברירת המחדל. יש להזין תוכן לכל שפה פעילה.',
    dbInfoMap: 'מרכז המפה בתחילת המשחק. פתח Google Maps, לחץ לחיצה ימנית על מקום ההתחלה והעתק את הקואורדינטות.',
    dbInfoLastPoint: 'מספר הנקודה שמפעיל את סיום המשחק. מתאים לנקודה האחרונה שנוצרה בעורך.',
    dbInfoVisitOrder: 'רשימת מספרי נקודות בסדר הביקור. הפרד בפסיקים. לדוג. 1, 2, 3, 4, 5.',

    // ── Wizard ───────────────────────────────────────────
    wizStep1Title: 'שלב 1 — מסך ניווט',
    wizStep1Hint: 'בחרו מה השחקנים יראו בשלב זה של המסלול.',
    wizStep2Title: 'שלב 2 — מסך מידע (אופציונלי)',
    wizStep2Hint: 'בחרו סוג מידע אחד או יותר להצגה לפני התרגיל. השאירו ריק כדי לעבור ישירות לתרגיל.',
    wizStep3Title: 'שלב 3 — תרגיל',
    wizStep3Hint: 'בחרו את סוג התרגיל שהשחקנים יצטרכו להשלים בנקודה זו.',
    wizNext: 'הבא →',
    wizBack: '→ חזרה',
    wizSavePoint: '✅ שמור נקודה',
    wizOptImageListName: 'גלריית תמונות',
    wizOptImageListDesc: 'תמונה של אלמנט הנראה מהמקום. השחקנים צריכים למצוא את המיקום.',
    wizOptDynamicMapDesc: 'השחקנים מנווטים על מפה אינטראקטיבית כדי להגיע לנקודה זו.',
    wizOptCarouselDesc: 'מספר תמונות גוללות כדי להנחות את השחקנים אל המקום.',
    wizOptMissingWordDesc: 'שלט הנראה מהמקום עם מילה מוסתרת שהשחקנים צריכים למצוא.',
    wizPhotoLabel: '📷 תמונת הנקודה',
    wizImageListHint: 'בחרו תמונה של משהו הנראה בבירור מהמקום (בניין, פסל, שלט וכו\').',
    wizMissingWordImageHint: 'העלו את תמונת השלט. יהיה עליכם לציין להלן את המילה שהסתרתם עליו.',
    wizMapPositionLabel: '📍 מיקום על המפה',
    wizPickOnMapBtn: '📍 מקם על המפה',
    wizMissingWordFieldLabel: '🔤 מילה חסרה',
    wizMissingWordFieldHint: 'כתבו כאן את המילה שהסתרתם על השלט.',
    wizMissingWordPlaceholder: 'המילה המוסתרת...',
    wizOptNoInfoName: 'ללא מידע',
    wizOptNoInfoDesc: 'השחקנים עוברים ישירות לתרגיל.',
    wizOptTextDesc: 'פסקת מידע על המקום לקריאה.',
    wizOptAudioDesc: 'הקלטת שמע הקשורה למקום זה.',
    wizOptVideoDesc: 'סרטון YouTube לצפייה במקום.',
    wizOptARName: 'מציאות רבודה',
    wizOptARDesc: 'אפקט ויזואלי AR המוצג מעל תצוגת המצלמה.',
    wizOptPhoneName: 'שיחה מדומה',
    wizOptPhoneDesc: 'שיחת טלפון מדומה עם הודעה קולית.',
    wizTextInfoLabel: '📝 טקסט מידע',
    wizTextInfoPlaceholder: 'הזינו את הטקסט להצגה...',
    wizAudioLabel: '🎵 URL שמע',
    wizVideoLabel: '🎬 URL יוטיוב',
    wizCallerNameLabel: '📞 שם המתקשר',
    wizOptQuestionsName: 'שאלות',
    wizOptQuestionsDesc: 'שאלות רב-ברירה עם תשובה נכונה אחת.',
    wizOptPuzzleDesc: 'השחקנים מרכיבים מחדש תמונה על ידי הזזת חתיכות.',
    wizOptMultipleMatchName: 'התאמה',
    wizOptMultipleMatchDesc: 'השחקנים מתאימים תמונות לתוויות.',
    wizOptMemoryDesc: 'השחקנים הופכים קלפים כדי למצוא זוגות תואמים.',
    wizOptTrueFalseName: 'נכון / לא נכון',
    wizOptTrueFalseDesc: 'השחקנים מסמנים כל טענה כנכונה או שגויה.',
    wizOptFillBlanksName: 'השלמת טקסט',
    wizOptFillBlanksDesc: 'השחקנים משלימים טקסט עם מילים חסרות.',
    wizOptRushHourDesc: 'השחקנים מזיזים כלי רכב כדי לפנות מסלול.',
    wizOptSignCardName: 'כרטיס שלט',
    wizOptSignCardDesc: 'השחקנים מזהים מילה על שלט או לוחית.',
    onboardingAlert: '✏️ ניתן לשנות הכל בכל עת לאחר מכן — אל תדאגו!',
    settingsMapHint: 'כאן מגדירים את מרכז המפה שיוצג באפליקציה להנחיית השחקנים. מידע זה הינו חובה.',
    settingsPickOnMap: '📍 בחר על המפה',
    settingsCoordsUndefined: '⚠️ קואורדינטות לא הוגדרו — חובה',

    // ── Misc ──────────────────────────────────────────────
    loading: 'טוען…',
    noRoute: 'ללא מסלול Google',
    gps: 'GPS:',
  },
};

export default adminUI;
